/** The glyph a dashboard falls back to when it has no icon of its own. */
const DEFAULT_DASHBOARD_ICON = 'dashboard-square-02';

/**
 * The hugeicons class for a dashboard's icon.
 *
 * Dashboards persist the bare name (`car-parking-02`), and every consumer prefixes it: the menu
 * entry and the KPI strip card both build `hgi-${icon}`. The header bar takes the name as given
 * and only treats it as hugeicons when it already starts with `hgi`, falling back to a Material
 * ligature otherwise — which is how a bare name ended up printed as letters in the top bar.
 */
export function dashboardIconClass(icon: string | null | undefined): string {
  const name = icon?.trim() || DEFAULT_DASHBOARD_ICON;
  return name.startsWith('hgi-') ? name : `hgi-${name}`;
}
